import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import cart from './cart'
import locale from './locale/localeSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        cart,
        locale,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
